module.exports = __webpack_public_path__ + "cw.svg?9228b6a0f0e3eb82fef2feb35eb366b6";